import React, { createContext, useContext } from 'react';

export type IconLibrary = 'phosphor';

interface IconLibraryContextType {
  library: IconLibrary;
}

const IconLibraryContext = createContext<IconLibraryContextType>({
  library: 'phosphor',
});

export const IconLibraryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <IconLibraryContext.Provider value={{ library: 'phosphor' }}>
      {children}
    </IconLibraryContext.Provider>
  );
};

export const useIconLibrary = () => useContext(IconLibraryContext);
